import Group from '../entities/Group';

const readGroupsAll = () => ({
  type: 'READ_GROUPS_ALL'
});

const successReadGroupsAll = (groups: Group[]) => ({
  type: 'SUCCESS_READ_GROUPS_ALL',
  groups
});

const readGroupsRelated = () => ({
  type: 'READ_GROUPS_RELATED'
});

const successReadGroupsRelated = (groups: Group[]) => ({
  type: 'SUCCESS_READ_GROUPS_RELATED',
  groups
});

const createGroup = (group: Group) => ({
  type: 'CREATE_GROUP',
  group
});

const successCreateGroup = (group: Group) => ({
  type: 'SUCCESS_CREATE_GROUP',
  group
});

const updateGroup = (group: Group) => ({
  type: 'UPDATE_GROUP',
  group
});

const successUpdateGroup = (group: Group) => ({
  type: 'SUCCESS_UPDATE_GROUP',
  group
});

const destroyGroup = (group: Group) => ({
  type: 'DESTROY_GROUP',
  group
});

const successDestroyGroup = (group: Group) => ({
  type: 'SUCCESS_DESTROY_GROUP',
  group
});

export {
  readGroupsAll,
  successReadGroupsAll,
  readGroupsRelated,
  successReadGroupsRelated,
  updateGroup,
  successUpdateGroup,
  destroyGroup,
  successDestroyGroup,
  createGroup,
  successCreateGroup
};



// WEBPACK FOOTER //
// ./src/actions/group.ts